import React from 'react'

function Article(props) {
  return (
    <article>
  <h3>Let's round this up</h3>
  <p>In this session you'll practice every letter you've encountered so far.</p>
  <p></p>
    </article>
  )
}

export default Article
